"use client";

import { useEffect, useState } from "react";
import { FAVORITE_SETTING } from "../../setting/setting";
import { useGetFavorite } from "@/core-nextv3/favorite/favorite.use";
import { useAppContext } from "../Providers/app.providers";
import { useProductContext } from "../Providers/product.providers";
import { useStoreContext } from "../Providers/store.providers";
import { useResponsive } from "@/core-nextv3/util/useResponsive";
import dynamic from "next/dynamic";
import { hasStockByListVariant } from "@/core-nextv3/stock/stock.util";
import { trackEvent, TrackTypes } from "@/core-nextv3/track/track";
import { useCore } from "@/core-nextv3/core/core";

const ProductDesktop = dynamic(() => import("../Views/desktop/pages/Product").then((mod) => mod.ProductDesktop), 
    {
        ssr : false,
    });

const ProductMobile = dynamic(() => import("../Views/mobile/pages/Product").then((mod) => mod.ProductMobile), 
    {
        ssr : false,
    });

const ProductDisplay = ({ 
    product, 
    color,
    images,
    videos,
    tablePerson,
    comments,
    relatedProducts
}: any) => 
{
    const { isDesktop } = useResponsive();
    const [ hasFavorite, setHasFavorite ] = useState(false);
    const { accountData } = useAppContext();
    const { colorTableData } = useStoreContext();
    const { exchangeData, featuresProductData } = useProductContext();
    const [ variantColor, setVariantColor ] = useState<any>(color);
    const { user } = useCore();
    const [ variantSize, setVariantSize ] = useState<any>(() => 
    {
        const defaultVariant = product?.variant[1]?.items?.find((item:any) => 
            hasStockByListVariant(product, [ color, item ])
        );

        return defaultVariant;
    });
        
    // FAVORITE
    useGetFavorite(FAVORITE_SETTING.merge({
        document : {
            referencePath : product?.referencePath,
        },
        variant : [ variantColor ]
    }),
    (status:boolean) => 
    {
        setHasFavorite(status);
    });

    useEffect(() => 
    {
        if (variantColor && variantSize)
        {
            let category = "";
    
            if (product.categories && product.categories.length > 0)
            {
                const singleCategory = product.categories[product.categories.length - 1];
                category = singleCategory.name;
            }
    
            trackEvent(TrackTypes.ViewContent, {
                product  : product,
                category : category,
                variant  : [ variantColor, variantSize ],
                user,
            });
        }
    
    }, []);

    return (
        <>
            {isDesktop ? <ProductDesktop
                account={accountData}
                product={product} 
                images={images}
                videos={videos}
                variantColor={variantColor}
                setVariantColor={setVariantColor}
                variantSize={variantSize}
                setVariantSize={setVariantSize}
                features={featuresProductData} 
                colorTable={colorTableData}                 
                tablePerson={tablePerson}
                comments={comments}
                relatedProducts={relatedProducts}
                exchange={exchangeData}
                hasFavorite={hasFavorite}
                setHasFavorite={setHasFavorite}
            /> :
                <ProductMobile
                    account={accountData}
                    product={product} 
                    relatedProducts={relatedProducts}
                    images={images}
                    videos={videos}
                    variantColor={variantColor}
                    setVariantColor={setVariantColor}      
                    variantSize={variantSize}
                    setVariantSize={setVariantSize}          
                    features={featuresProductData} 
                    exchange={exchangeData} 
                    colorTable={colorTableData} 
                    hasFavorite={hasFavorite}
                    comments={comments}
                    tablePerson={tablePerson}
                    setHasFavorite={setHasFavorite}
                />  
            }    
        </>        
    )
}

export { ProductDisplay }